'use client'

import { IEnvService } from '@/core/services/env/env-service'
import { initializeApp } from 'firebase/app'
import {
  getMessaging,
  getToken,
  Messaging,
  onMessage,
} from 'firebase/messaging'
import { envService } from '../services/env'
import { NotificationModel } from '../types/models/notification.model'
import { createFirebaseConfig } from './config'

let messaging: Messaging | null = null

const initMessaging = (envService: IEnvService): Messaging | null => {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service workers are not supported in this browser')
    return null
  }
  if (messaging) return messaging

  const app = initializeApp(createFirebaseConfig(envService))
  messaging = getMessaging(app)
  return messaging
}

export function createRequestNotificationPermission(_: {
  envService: IEnvService
}) {
  return async function (): Promise<{ fcmToken: string } | null> {
    try {
      const messaging = initMessaging(envService)
      if (!messaging) return null

      const permission = await Notification.requestPermission()
      if (permission !== 'granted') {
        console.warn('Notification permission not granted')
        return null
      }

      const fcmToken = await getToken(messaging)
      if (!fcmToken) return null

      return { fcmToken }
    } catch (err) {
      console.error('Failed to get FCM token:', err)
      return null
    }
  }
}

export function createMessagesListener(_: { envService: IEnvService }) {
  return function (onNotification: (notification: NotificationModel) => void) {
    const messaging = initMessaging(envService)
    if (!messaging) {
      return { unsubscribe: () => {} }
    }
    const unsubscribe = onMessage(messaging, ({ notification, data }) => {
      if (data?.metaData) {
        const { metaData, ...rest } = data
        return onNotification({
          notification,
          metaData: JSON.parse(metaData),
          data: rest,
        })
      }
      onNotification({ notification, data })
    })

    return { unsubscribe }
  }
}
